export const PIWIK_CONTAINER_ID = process.env.NEXT_PUBLIC_PIWIK_CONTAINER_ID || 'e583728b-270d-4760-92d1-d09b1c49b4b1'
export const PIWIK_CONTAINER_URL = process.env.NEXT_PUBLIC_PIWIK_CONTAINER_URL || 'https://fortnox.containers.piwik.pro'
export const ENABLED = process.env.NEXT_PUBLIC_PIWIK_ENABLED === 'true' || false
